// 筛选栏控件与表格列的固定宽度，按内容类型取 tokens.json 里的 filter-w-*、col-w-* 令牌（#541，决策 D199）。

/** 筛选栏控件的初始宽度，按条件类型固定：Combobox、Select 传给 width，Input 写进 style.width。 */
export const FILTER_W = {
  code: "var(--filter-w-code)",
  codePick: "var(--filter-w-code-pick)",
  num: "var(--filter-w-num)",
  date: "var(--filter-w-date)",
  msisdn: "var(--filter-w-msisdn)",
  select: "var(--filter-w-select)",
  search: "var(--filter-w-search)",
  id: "var(--filter-w-id)",
} as const;

/** 表格列宽的类型；个别列内容特殊时直接给像素。 */
export type ColWidth = "code" | "op" | "id" | "num" | "status" | "money" | "date" | "time" | "name" | "wide" | number;

/** 列宽类型对应的 CSS 宽度。 */
export const colWidth = (w: ColWidth) => (typeof w === "number" ? `${w}px` : `var(--col-w-${w})`);
